import React, { useEffect, useRef } from 'react'
import UserProfile from './UserProfile'
import AcademicDetails from './AcademicDetails'
import Help from './Help'
import TermsPolicies from './TermsPolicies'
import AppLink from './AppLink'
import 'HELPDESK/CommonResources/UserProfilePanel/userprofilepanel.css'
import config from 'config'
import { X } from 'lucide-react';

const UserProfilePanel = (props) => {
    const modalRef = useRef(null); // Create a ref for the modal

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            props.handleModalOpenClose('userInfo')
        }
    };

    useEffect(() => {
        if (props.userInfoModal) {
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade in';
            document.body.appendChild(backdrop);
        } else {
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) document.body.removeChild(backdrop);
        }

        return () => {
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) document.body.removeChild(backdrop);
        };
    }, [props.userInfoModal]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside); // Cleanup on unmount
        };
    }, []);

    // METHOD TO SIGN OUT
    const userSignOut = () => {
        props.history.push(`${config.RootUrl}/vmlogout.php`)
    }

    if (config.institute_name === '' || config.institute_name === undefined) {
        config.institute_name = 'vmedulife';
    }

    return (
        <div className={props.userInfoModal ? "modal fade in" : "modal fade"} id="modalContainer" style={{ display: props.userInfoModal ? 'block' : 'none' }}>
            <div
                id="moduleDropdown" aria-labelledby="dropdownMenuButton"
                className="modal-content workspace-current-modal-mode user-mobile-mode scrollbar-narrow"
                style={{
                    position: "absolute",
                    top: "3rem",
                    right: "0",
                    padding: '5px',
                    zIndex: 9999,
                    width: '18vw',
                    minWidth: '20vw',
                    height: "calc(100vh - 4rem)",
                    overflowY: 'auto',
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',

                }}
                ref={modalRef}
            >
                <div className="config-icon-background-rounded ml-auto cursor-pointer mr-2 mt-2" onClick={() => props.handleModalOpenClose("userInfo")}>
                    <X size={18} />
                </div>

                <div className='mainContainer custom-scrollable-div'>

                    <UserProfile userSignOut={userSignOut} />
                    <AcademicDetails />
                    <Help />
                    <TermsPolicies />
                    <AppLink />
                </div>

            </div>
        </div>

    )
}

export default UserProfilePanel
